import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom"; // Ajout de Link
import { Helmet } from 'react-helmet';
import Footer from "../Components/footer";
import './services.css';




import service_details  from '../img/service/fret_maritime.svg';
import service2_details from '../img/service/Terrestre.svg';
import service3_details  from '../img/service/fret_aerien.svg';
import service4_details from '../img/service/transit_et_dedouanement.svg';
import { useTranslation } from "react-i18next";

function Services() {
    const { t } = useTranslation();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState("home");

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const service = params.get("service");
        console.log("Service sélectionné :", service);
        if (service === "terrestre") {
            setActiveTab("profile");
        } else if (service === "fret-aerien") {
            setActiveTab("messages");
        } else if (service === "douane") {
            setActiveTab("douane");
        } else {
            setActiveTab("home");
        }
    }, [location]);

    return (
        <div>
            <Helmet>
                <title>{t('services.title')}</title>
                <meta name="description" content={t('services.description')} />
                <meta name="keywords" content={t('services.keywords')} />
            </Helmet>
            <div className="bradcam_area bradcam_area2 bradcam_bg_2">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="bradcam_text text-center">
                                <h3>{t('NosServices')}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="service_details_area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-4">
                            <div className="service_details_left">
                                <div className="nav nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                    <Link className={activeTab === "home" ? 'active' : ''} to="?service=fret-maritime">{t('Fret maritime')}</Link>
                                    <Link className={activeTab === "profile" ? 'active' : ''} to="?service=terrestre">{t('Terrestre')}</Link>
                                    <Link className={activeTab === "messages" ? 'active' : ''} to="?service=fret-aerien">{t('Fret Aerien')}</Link>
                                    <Link className={activeTab === "douane" ? 'active' : ''} to="?service=douane">{t('Dédouanement')}</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-8">
                            <div className="tab-content" id="v-pills-tabContent">
                                <div className={`tab-pane fade ${activeTab === "home" ? "show active" : ""}`} id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
                                    <div className="service_details_info">
                                        <h3>{t('Fret maritime')}</h3>
                                        <p>{t('desc1service1')}</p>
                                        <p>{t('desc2service1')}</p>
                                        <p>{t('desc3service1')}</p>
                                        <p>{t('desc4service1')}</p>
                                        <p>{t('desc5service1')}</p>
                                        <p>{t('desc6service1')}</p>
                                        <p>{t('desc7service1')}</p>
                                        <p>{t('desc8service1')}</p>
                                        <p>{t('desc9service1')}</p>
                                    </div>
                                    <div className="service_thumb">
                                        <img src={service_details} alt="Service de fret maritime" />
                                    </div>
                                </div>
                                <div className={`tab-pane fade ${activeTab === "profile" ? "show active" : ""}`} id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab">
                                    <div className="service_details_info">
                                        <h3>{t('Terrestre')}</h3>
                                        <p>{t('desc1service2')}</p>
                                        <p>{t('desc2service2')}</p>
                                        <p>{t('desc3service2')}</p>
                                    </div>
                                    <div className="service_thumb">
                                        <img src={service2_details} alt="Service terrestre" />
                                    </div>
                                </div>
                                <div className={`tab-pane fade ${activeTab === "messages" ? "show active" : ""}`} id="v-pills-messages" role="tabpanel" aria-labelledby="v-pills-messages-tab">
                                    <div className="service_details_info">
                                        <h3>{t('Fret Aerien')}</h3>
                                        <p>{t('desc1service3')}</p>
                                        <p>{t('desc2service3')}</p>
                                        <p>{t('desc3service3')}</p>
                                        <ul>
                                            <li><p>{t('desc4service3')}</p></li>
                                            <li><p>{t('desc5service3')}</p></li>
                                            <li><p>{t('desc6service3')}</p></li>
                                            <li><p>{t('desc7service3')}</p></li>
                                            <li><p>{t('desc8service3')}</p></li>
                                        </ul>
                                    </div>
                                    <div className="service_thumb">
                                        <img src={service3_details} alt="Service de fret aérien" />
                                    </div>
                                </div>
                                <div className={`tab-pane fade ${activeTab === "douane" ? "show active" : ""}`} id="v-pills-douane" role="tabpanel" aria-labelledby="v-pills-douane-tab">
                                    <div className="service_details_info">
                                        <h3>{t('Dédouanement')}</h3>
                                        <p>{t('desc1service4')}</p>
                                        <p>{t('desc2service4')}</p>
                                        <p>{t('desc3service4')}</p>
                                        <p>{t('desc4service4')}</p>
                                        <p>{t('desc5service4')}</p>
                                        <p>{t('desc6service4')}</p>
                                        <p>{t('desc7service4')}</p>
                                        <p>{t('desc8service4')}</p>
                                    </div>
                                    <div className="service_thumb">
                                        <img src={service4_details} alt="Service de dédouanement" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}

export default Services;
